import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import HomePage from './components/Home/HomePage.vue'
import Login from './components/Account/LoginComp.vue'
import Register from './components/Account/RegisterComp.vue'
import FinalRegister from './components/Account/FinalRegister.vue'
import Profile from './components/Account/ProfilPage.vue'
import ShoppingList from './components/ShoppingList/ShoppingListPage.vue'
import MenuPage from './components/Menus/MenuPage.vue'
import MyIngredients from './components/Kitchen/Ingredients/MyIngredients.vue'
import WelcomePage from './components/Utils/WelcomePage.vue'
import ContactPage from './components/PublicPages/ContactPage.vue'
import FaqPage from './components/PublicPages/FaqPage.vue'
import PartnersPage from './components/PublicPages/PartnersPage.vue'
import TermsPage from './components/PublicPages/TermsPage.vue'
import PrivacyPage from './components/PublicPages/PrivacyPage.vue'
import CookiesPage from './components/PublicPages/CookiesPage.vue'
import LegalPage from './components/PublicPages/LegalPage.vue'
import AddIngredients from './components/Kitchen/Ingredients/AddIngredients.vue'

import { createRouter, createWebHashHistory } from 'vue-router';
import i18n from './i18n'
import { createPinia } from 'pinia'


import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

initializeApp(firebaseConfig);

loadFonts()

import { getAuth, onAuthStateChanged } from "firebase/auth";
import PasswordEditPage from './components/Account/PasswordEditPage.vue'
import EditPreferences from './components/Account/EditPreferences.vue'
import MyRecipes from './components/Kitchen/Recipes/MyRecipes.vue'
import AddRecipe from './components/Kitchen/Recipes/AddRecipe.vue'
import RecipeDetails from './components/Kitchen/Recipes/RecipeDetails.vue'
import AddEditBaseIngredients from './components/Kitchen/Ingredients/AddEditBaseIngredients.vue'
import BaseRecipesCatalog from './components/Kitchen/Recipes/BaseRecipesCatalog.vue'
import AddEditBaseRecipes from './components/Kitchen/Recipes/AddEditBaseRecipes.vue'
import BaseIngredientsCatalog from './components/Kitchen/Ingredients/BaseIngredientsCatalog.vue'
import AddCsvRecipes from './components/Kitchen/Recipes/AddCsvRecipes.vue'
import AddEditHiddenBaseIngredients from './components/Kitchen/Ingredients/AddEditHiddenBaseIngredients.vue'

// Importer le store auth pour accéder aux infos utilisateur
import { useAuthStore } from './store/auth_store'

const routes = [ 
  { path: '/login', name: "login", component: Login, meta: { requiresAuth: false, hideAppChrome: true, hideFooter: true }},
  { path: '/register', name: "register", component: Register, meta: { requiresAuth: false, hideAppChrome: true, hideFooter: true }},
  { path: '/final_register', name: "final_register", component: FinalRegister, meta: { requiresAuth: false, hideAppChrome: true, hideFooter: true }},

  // Requiring authentication
  { path: '/welcome', name: "welcome", component: WelcomePage, meta: { requiresAuth: false, hideAppChrome: true }},
  { path: '/contact', name: 'contact', component: ContactPage, meta: { requiresAuth: false, hideAppChrome: true }},
  { path: '/faq', name: 'faq', component: FaqPage, meta: { requiresAuth: false, hideAppChrome: true }},
  { path: '/partenaires', name: 'partenaires', component: PartnersPage, meta: { requiresAuth: false, hideAppChrome: true }},
  { path: '/conditions-generales', name: 'conditions_generales', component: TermsPage, meta: { requiresAuth: false, hideAppChrome: true }},
  { path: '/politique-confidentialite', name: 'politique_confidentialite', component: PrivacyPage, meta: { requiresAuth: false, hideAppChrome: true }},
  { path: '/politique-cookies', name: 'politique_cookies', component: CookiesPage, meta: { requiresAuth: false, hideAppChrome: true }},
  { path: '/mentions-legales', name: 'mentions_legales', component: LegalPage, meta: { requiresAuth: false, hideAppChrome: true }},
  { path: '/', name: "home", component: HomePage, meta: { requiresAuth: true, breadcrumb: 'Accueil' } },
  { path: '/profile', name: "profile", component: Profile, meta: { requiresAuth: true, breadcrumb: 'Mon profil' }},
  { path: '/shopping_list', name: "ShoppingList", component: ShoppingList, meta: { requiresAuth: true, breadcrumb: 'Mes listes' }},
  { path: '/menu', name: "menu", component: MenuPage, meta: { requiresAuth: true, breadcrumb: 'Mes menus' }},
  { path: '/my_recipes', name: "my_recipes", component: MyRecipes, meta: { requiresAuth: true, breadcrumb: 'Mes recettes' }},
  { path: '/my_ingredients', name: "my_ingredients", component: MyIngredients, meta: { requiresAuth: true, breadcrumb: 'Mes ingrédients' }},
  { path: '/add_ingredient', name: "add_ingredient", component: AddIngredients, meta: { requiresAuth: true, breadcrumb: 'Ajouter un ingrédient' }},
  { path: '/add_recipe', name: "add_recipe", component: AddRecipe, meta: { requiresAuth: true, breadcrumb: 'Ajouter une recette' }},
  { path: '/browse_base_recipes', name: "browse_base_recipes", component: BaseRecipesCatalog, meta: { requiresAuth: true, breadcrumb: 'Catalogue de recettes' }},
  { path: '/browse_base_ingredients', name: "browse_base_ingredients", component: BaseIngredientsCatalog, meta: { requiresAuth: true, breadcrumb: 'Catalogue d\'ingrédients de base' }},

  // Routes admin uniquement
  { path: '/base_recipes', name: "base_recipes", component: AddEditBaseRecipes, meta: { requiresAuth: true, requiresAdmin: true, breadcrumb: 'Modifier les recettes de base' }},
  { path: '/base_ingredients', name: "base_ingredients", component: AddEditBaseIngredients, meta: { requiresAuth: true, requiresAdmin: true, breadcrumb: 'Modifier les ingrédients de base' }},
  { path: '/hidden_base_ingredients', name: "hidden_base_ingredients", component: AddEditHiddenBaseIngredients, meta: { requiresAuth: true, requiresAdmin: true, breadcrumb: 'Modifier les ingrédients de base cachés' }},
  { path: '/base_recipes_import', name: "base_recipes_import", component: AddCsvRecipes, meta: { requiresAuth: true, requiresAdmin: true, breadcrumb: 'Importer des recettes de base' }},

  { path: '/edit_preferences', name: "edit_preferences", component: EditPreferences, meta: { requiresAuth: true, breadcrumb: 'Modifier mes préférences' } },
  { path: '/reset-password',  name: 'ResetPassword',  component: PasswordEditPage },
  { path: '/references', redirect: '/partenaires' },
  { path: '/:pathMatch(.*)*', redirect: '/welcome' },
  {
    path: '/recipe/:id',
    name: 'recipe_detail',
    component: RecipeDetails,
    props: route => ({ id: route.params.id }) // on passe l'id en prop
  }
];

const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(getAuth(), (user) => {
      removeListener()
      resolve(user)
    },
    reject,
    );
  });
};
  
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
});

router.beforeEach(async (to, from, next) => {
  // Vérifier si la route nécessite une authentification
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const currentUser = await getCurrentUser();
    
    if (currentUser) {
      // Vérifier si la route nécessite un accès admin
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        // Récupérer le store auth (initialisé après création de l'app)
        const authStore = useAuthStore();
        
        // Attendre que userInfos soit chargé si nécessaire
        if (!authStore.userInfos) {
          await new Promise(resolve => {
            const stop = setInterval(() => {
              if (authStore.userInfos !== null) {
                clearInterval(stop);
                resolve();
              }
            }, 100);
            setTimeout(() => { clearInterval(stop); resolve(); }, 3000);
          });
        }
        // Vérifier si l'utilisateur est admin
        if (authStore.userInfos && authStore.userInfos.role === 'admin') {
          next();
        } else {
          // Rediriger vers la page d'accueil si pas admin
          console.warn('Accès refusé : droits admin requis');
          next({ path: '/' });
        }
      } else {
        // Route normale nécessitant juste l'authentification
        next();
      }
    } else {
      // Pas connecté, rediriger vers welcome
      next({ path: '/welcome' });
    }
  } else {
    // Route ne nécessitant pas d'authentification
    if ((to.path === '/register' || to.path === '/login') && await getCurrentUser()) {
      next({ path: '/' });
    } else {
      next();
    }
  }
});

const pinia = createPinia();

createApp(App)
  .use(vuetify)
  .use(pinia)
  .use(router)
  .use(i18n)
  .mount('#app')
